import { render, staticRenderFns } from "./QuestionAndAnswerSearchComponent.vue?vue&type=template&id=00207562&scoped=true&"
import script from "./QuestionAndAnswerSearchComponent.vue?vue&type=script&lang=js&"
export * from "./QuestionAndAnswerSearchComponent.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAndAnswerSearchComponent.vue?vue&type=style&index=0&id=00207562&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00207562",
  null
  
)

export default component.exports